import {
  Component,
  Input,
  OnInit,
  OnChanges,
  OnDestroy,
} from '@angular/core';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { v4 } from 'uuid';

import {
  Chart,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

import { ChartType } from '../../interfaces/global/chart';

@Component({
  selector: 'app-chart',
  imports: [],
  templateUrl: './chart.component.html',
  styleUrl: './chart.component.scss',
})
export abstract class ChartComponent implements OnInit, OnChanges, OnDestroy {
  @Input() width: number | undefined = undefined;
  @Input() height: number | undefined = undefined;
  @Input() isLoading: boolean = false;

  refElementName: string = 'barchartcanvas';

  chart: Chart | undefined;
  id: string;

  fontSize: number = 16;

  colorMap: { [key: string]: string } = {
    '--casper': '#BFC1C3',
    '--boulder': '#D1D1D1',
    '--text': '#395160',
  };

  protected chartType: ChartType = 'bar';

  constructor() {
    this.id = 'chart-' + v4();

    Chart.register(
      CategoryScale,
      LinearScale,
      Title,
      Tooltip,
      Legend,
      ChartDataLabels
    );
  }

  ngOnInit(): void {
    if (this.width) {
      this.fontSize = this.width * 0.08;
      this.fontSize = Math.max(this.fontSize, 14);
    }
  }

  ngOnDestroy(): void {
    if (this.chart) {
      console.log('Destroying chart...');
      this.chart.destroy();
      this.chart = undefined;
    }
  }

  ngOnChanges(): void {}
  abstract setEmptyOptions(): void;
  abstract setLoadingOptions(): void;
  abstract setDataOptions(): void;
  abstract isDataAvailable(): boolean;
}
